module.exports = __webpack_public_path__ + "img/ic24DeleteBlack.009993a3.svg";